import { lazy } from "react";
import RoleSwitch from "modules/swiftboard/components/RoleSwitch";

// /swiftboard/overview — role-based page
const pages = {
  ADMIN:  lazy(() => import("./admin/OverView")),
  CLIENT: lazy(() => import("./client/Overview")),
};

export default function Overview() {
  return <RoleSwitch pages={pages} />;
}
